import React from 'react';
import PrivacyContent from 'components/root/terms/privacy/PrivacyContent';

export const PrivacyPage: React.FC = () => {
  return <PrivacyContent />;
};
